import { Controller } from "remult";

@Controller("image-methods")
export class ImageMethods {}
